<template>
  <div class="vcv-sidebar-navigation">
    <ul>
      <li v-for="item in navigationItems" :key="item.routeName">
        <router-link
          tag="a"
          :to="{ name: item.routeName }"
          :class="{ disabled: item.isDisabled || isFeatureDisabledByTariff(item.feature) }"
        >
          {{ item.title }}
        </router-link>

        <vcv-billing-lock
          v-if="item.feature !== undefined && isFeatureDisabledByTariff(item.feature)"
          :feature="item.feature"
          class="vcv-sidebar-navigation__lock"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VcvBillingLock from '@/routes_new/inner/billing/VcvBillingLock';

export default {
  name: 'VcvSidebarNavigation',

  components: {
    VcvBillingLock
  },

  props: {
    navigationItems: {
      type: [Object, Array],
      default: () => []
    }
  },

  computed: {
    ...mapGetters('company_new', ['isFeatureDisabledByTariff'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vcv-sidebar-navigation {
  margin: 0;
  width: 244px;
  min-width: 244px;
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 20px 0;

  @media screen and (max-width: 820px) {
    width: 100%;
    min-height: auto;
    padding: 0 20px;
  }

  ul {
    @media screen and (max-width: 820px) {
      display: flex;
    }
  }

  ul li {
    list-style: none;
    @include mixin-text-main;
    display: flex;
    justify-content: space-between;

    &:hover {
      background: $background;
      transition: all 0.3s;
    }
  }

  ul li a {
    display: block;
    padding: 11px 30px;
    position: relative;
    color: $main-dark;
    display: flex;
    width: 100%;
    align-items: center;
    transition: all 0.3s;

    @media screen and (max-width: 820px) {
      padding: 15px;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 3px;
      background: transparent;
      transition: background 0.3s;
    }

    &:focus,
    &:active {
      color: $green;
      transition: all 0.3s;
    }

    &.router-link-exact-active {
      color: $green;

      &:before {
        background: $green;
        transition: background 0.3s;

        @media screen and (max-width: 820px) {
          width: 100%;
          height: 3px;
          top: auto;
          bottom: 0;
        }
      }
    }

    &.disabled {
      pointer-events: none;
      cursor: not-allowed;
      opacity: 0.8;
      color: $grey;
      padding-right: 30px;
    }
  }

  &__lock {
    margin-right: 10px;
  }
}
</style>
